import { render, staticRenderFns } from "./TestTab.vue?vue&type=template&id=2fa36ea2&"
import script from "./TestTab.vue?vue&type=script&lang=js&"
export * from "./TestTab.vue?vue&type=script&lang=js&"
import style0 from "./TestTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports